export const spamcontrolUserId = 29883384

// The below two functions need to be replaced and processed locally on the client, 
// as they are hard-coded with the settings at the time of build, so if a package
// is built for prod, and installed on beta, all the URLs it constructs will be
// prod ones :(
 const mainHost = (): string => {
    switch (process.env.VUE_APP_ENVIRONMENT) {
    case 'development':
    case 'staging':
        return 'alpha.freecycle.org'
    case 'alpha':
        return 'alpha.freecycle.org'
    case 'beta':
        return 'beta.freecycle.org'
    default:
        return 'www.freecycle.org'
    }
};

const modHost = (): string => {
    switch (process.env.VUE_APP_ENVIRONMENT) {
    case 'development':
        case 'staging':
            return 'stagingmoderator.freecycle.org'
        case 'alpha':
            return 'alphamoderator.freecycle.org'
        case 'beta':
            return 'betamoderator.freecycle.org'
        default:
            return 'moderator.freecycle.org'
    }
};

export const fc3MainHostname = mainHost();
export const fc3ModHostname = modHost();

export const offer = 1;
export const taken = 2;
export const wanted = 3;
export const received = 4;
export const lend = 9;
export const borrow = 10;

export const vue_app_version = require('../../package.json').version;